import api from '@/utils/api';
import {
    FETCH_CUS_SERVICE_MILESTONES,
    FETCH_CUS_SERVICE_MILESTONE_DETAIL,
    CREATE_CUS_SERVICE_MILESTONE,
    UPDATE_CUS_SERVICE_MILESTONE,
    DELETE_CUS_SERVICE_MILESTONES,
    UPDATE_CUS_SERVICE_MILESTONE_FIELD,
    NOTIFICATION_CUS_SERVICE_MILESTONES
} from './types';
import { NotificationManager } from 'react-notifications';

/**
 * Lấy danh sách milestones với điều kiện lọc và phân trang.
 * @param {Object} filters { keyword, service_id, status, page, per_page }
 */
export const fetchCusServiceMilestones = (filters = {}) => dispatch => {
    return api.get('/cus-service-milestones', { params: filters }).then(res => {
        dispatch({ type: FETCH_CUS_SERVICE_MILESTONES, payload: res.data.data });
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể tải danh sách milestones');
        throw err;
    });
};

/**
 * Lấy chi tiết milestone theo ID.
 * @param {number} id
 */
export const fetchCusServiceMilestoneDetail = (id) => dispatch => {
    return api.get(`/cus-service-milestones/${id}`).then(res => {
        dispatch({ type: FETCH_CUS_SERVICE_MILESTONE_DETAIL, payload: res.data.data });
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể lấy chi tiết milestone');
        throw err;
    });
};

/**
 * Tạo milestone mới.
 * @param {Object} data
 */
export const createCusServiceMilestone = (data) => dispatch => {
    return api.post('/cus-service-milestones', data).then(res => {
        dispatch({ type: CREATE_CUS_SERVICE_MILESTONE, payload: res.data.data });
        NotificationManager.success(res.data.msg || 'Tạo milestone thành công');
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Tạo milestone thất bại');
        throw err;
    });
};

/**
 * Cập nhật milestone theo ID.
 * @param {number} id
 * @param {Object} data
 */
export const updateCusServiceMilestone = (id, data) => dispatch => {
    return api.put(`/cus-service-milestones/${id}`, data).then(res => {
        dispatch({ type: UPDATE_CUS_SERVICE_MILESTONE, payload: res.data.data });
        // bổ sung action merge field
        dispatch({
            type: UPDATE_CUS_SERVICE_MILESTONE_FIELD,
            payload: { id, data }
        });
        NotificationManager.success(res.data.msg || 'Cập nhật milestone thành công');
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Cập nhật milestone thất bại');
        throw err;
    });
};

/**
 * Xoá nhiều milestones theo danh sách ID.
 * @param {number[]} ids
 */
export const deleteCusServiceMilestones = (ids) => dispatch => {
    return api.delete('/cus-service-milestones', { data: { ids } }).then(res => {
        dispatch({ type: DELETE_CUS_SERVICE_MILESTONES, payload: ids });
        NotificationManager.success(res.data.msg || 'Xoá milestone thành công');
        return res.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Xoá milestone thất bại');
        throw err;
    });
};

export const notifyCusServiceMilestone = (id, data) => dispatch => {
    return api.post(`/cus-service-milestones/${id}/notify`, data)
        .then(res => {
            dispatch({ type: NOTIFICATION_CUS_SERVICE_MILESTONES, payload: res.data.data });
            return res.data.data;
        })
        .catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Không gửi được thông báo');
            throw err;
        });
};
